//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";

export default {
    name: "BulkInviteModal",
    components: {
        AQModal,
        AQButton,
        AQDialog,
        AQTooltip,
        AQUploader,
        AQRadio
    },
    props: {},
    data() {
        return {
            uploadedData: [],
            invalidEntries: 0,
            showDialog: false,
            availableUsers: [],
            userStatus: "DIS",
            url: "/identity/invite/principal/parse-file",
            isUploaded: false,
            csvDlFile: "/docs/ExcelDownloadTemplate.csv",
            xlsDlFile: "/docs/ExcelDownloadTemplate.xls",
            xlsxDlFile: "/docs/ExcelDownloadTemplate.xlsx",
            showInviteModal: true,
            save: {
                label: this.$t("adminUsersGroups.doneBtn"),
                disabled: false
            },
            tableData: [],
            dialogMessage: "",
            dialogTitle: "",
            isAlert: false,
            fileUploaded: false,
            errorStyle: false,
            invalidFile: false
        };
    },
    computed: {
        setEntriesHeader() {
            return `${this.tableData.length} ${this.$tc("adminUsersGroups.bulkInviteModalListing", this.tableData.length)}`;
        },
        setEntriesNumber() {
            this.getInvalidEntries();
            return this.invalidEntries ? ` - ${this.invalidEntries} ${this.$t("adminUsersGroups.bulkInviteModalInvalidEntries")}` : "";
        }
    },
    methods: {
        ...mapActions("admin", ["parseUsersFile", "createNewInvitedUser"]),
        actionsDlg(evt) {
            this.isAlert = false;
            if (evt === "save") {
                if (this.invalidFile) {
                    this.dialogMessage = this.$t("adminUsersGroups.invalidFileText");
                    this.dialogTitle = this.$t("adminUsersGroups.invalidFile");
                    this.isAlert = true;
                    this.showDialog = true;
                } else if (!this.fileUploaded) {
                    this.errorStyle = true;
                } else if (this.invalidEntries) {
                    const indexParams = {
                        invalidEntries: this.invalidEntries,
                        totalEntries: this.tableData.length,
                        availableEntries: this.tableData.length - this.invalidEntries
                    };
                    if (indexParams.availableEntries === 0) {
                        this.dialogMessage = this.$t("adminUsersGroups.noAvailableEmails");
                        this.dialogTitle = this.$t("adminUsersGroups.noAvailableEmailsTitle");
                        this.isAlert = true;
                    } else {
                        this.dialogMessage = `${this.$t("adminUsersGroups.dialogMessage", indexParams)}
                                            ${this.$tc("adminUsersGroups.emailAddress", indexParams.availableEntries)}`;
                        this.dialogTitle = this.$t("adminUsersGroups.dialogTitle");
                    }
                    this.showDialog = true;
                } else {
                    this.sendEmails();
                }
            } else if (evt === "close") {
                this.tableData = [];
                this.$emit("input", false);
            }
        },
        getInvalidEntries() {
            this.availableUsers = this.tableData.filter(
                user => user.valid && user.validPhoneNumber
            );
            this.invalidEntries = this.tableData.length - this.availableUsers.length;
        },
        sendEmails() {
            if (this.isAlert) {
                this.showDialog = false;
            } else {
                this.createNewInvitedUser({ activateUsers: this.userStatus === "ACT", users: this.availableUsers }).then(
                    this.$emit("showSuccessToast", this.availableUsers.length)
                );
                this.$emit("input", false);
            }
        },
        dialogConfirmAction(action) {
            if (action === "ok") {
                this.sendEmails();
            }
        },
        setUploadFile(file) {
            this.uploadedData = file;
        },
        uploadFile(file) {
            if (file && file.length) {
                this.fileUploaded = true;
                const dataForm = new FormData();
                const fileBlob = new Blob([file[0]]);
                dataForm.append("attachment", fileBlob, file[0].name);
                this.isUploaded = true;
                this.parseUsersFile(dataForm).then(data => {
                    this.tableData = data.data;
                });
            } else {
                this.isUploaded = true;
                this.invalidFile = true;
            }
        },
        removeFile(file) {
            this.isUploaded = file && file.length;
            this.errorStyle = false;
            this.tableData = [];
            this.fileUploaded = false;
            this.invalidFile = false;
        },
        setRowBg(idx, item) {
            let background;
            const isValid = item.valid && item.validPhoneNumber;
            if (isValid) {
                background = idx % 2 === 0 ? "background-color:#FFFFFF" : "background-color:#FAFAFA";
            } else {
                background = "background: #EAB3B3";
            }
            return background;
        },
        createDlLink(file) {
            const getExport = document.createElement("a");
            getExport.setAttribute("href", file);
            document.body.appendChild(getExport);
            getExport.click();
            getExport.remove();
        },
        downloadFile(type) {
            if (type === "csv") {
                this.createDlLink(this.csvDlFile);
            } else if (type === "xls") {
                this.createDlLink(this.xlsDlFile);
            } else if (type === "xlsx") {
                this.createDlLink(this.xlsxDlFile);
            }
        }
    }
};
